<template>
    <div id="integrations">
        <status-message></status-message>

        <div v-if="apiKeysData.length > 0 || isSystemAdmin == true">
            <h2 class="td-h2">API Keys</h2>
        </div>

        <div v-if="isSystemAdmin == true" class="add-apikey my-2">
            <button @click="showAddApiKeyModal = !showAddApiKeyModal" class="td-btn secondary icon-left"><icon class="icon" type="solid" name="faPlus"></icon>Add API Key</button>
        </div>

        <div v-if="apiKeysData.length > 0" class="td-table-container mt-0">
            <table cellspacing="0" cellpadding="0" class="td-table">
                <thead>
                    <tr class="table-header">
                        <th>Name</th>
                        <th>API Key</th>
                        <th>Secret</th>
                        <th>Redirect Url</th>
                        <th class="td-text-right"></th>
                    </tr>
                </thead>
                <tbody class="rows-container">
                    <tr v-if="!isLoading && apiKeysData.length > 0" v-for="apiKey in apiKeysData" class="table-row main-row">
                        <td class="name">
                            {{ apiKey.name }}
                        </td>
                        <td class="api-key">
                            {{ apiKey.apiKey }}
                        </td>
                        <td class="api-secret">
                            <span v-if="canDisplaySecret(apiKey)">
                                {{ displaySecret(apiKey) }}
                                <span>
                                    <icon class="ml-1 td-text-primary td-link" name="faArrowsRotate" type="solid" @click="confirmRefreshApiKeyModal(apiKey)"></icon>
                                </span>
                            </span>
                            <span v-if="!canDisplaySecret(apiKey)" class="td-link" @click="getSecret(apiKey)">Show Secret</span>
                        </td>
                        <td class="redirect-url">
                            {{ apiKey.redirectUrl }}
                        </td>

                        <td class="td-text-right">
                            <button class="td-btn secondary-outlined slim mr-1" title="View" @click="showEditModal(apiKey)">
                                Edit
                            </button>
                            <button class="td-btn danger slim ml-1" title="Remove" @click="showRemoveModal(apiKey)">
                                Remove
                            </button>
                        </td>
                    </tr>
                    <tr v-if="isLoading"><td colspan="5"><div class="loading loading-table"><icon name="faSpinner" type="solid" spin></icon></div></td></tr>
                    <tr v-if="apiKeysData && apiKeysData.length < 1 && !isLoading"><td colspan="5"><p>No API keys registered.</p></td></tr>
                </tbody>
            </table>
        </div>


        <div>
            <h2 class="td-h2">API Authentication Tokens</h2>
        </div>

        <div class="request-apitoken my-2">
            <button @click="createApiToken" class="td-btn secondary">Create new Token</button>
        </div>

        <div class="td-table-container mt-0">
            <table cellspacing="0" cellpadding="0" class="td-table">
                <thead>
                    <tr class="table-header">
                        <th>API Authentication Token</th>
                        <th class="td-text-right"></th>
                    </tr>
                </thead>
                <tbody class="rows-container">
                    <tr v-if="!isLoading" v-for="apiToken in apiTokens" class="table-row main-row">
                        <td class="name">
                            <span v-if="apiToken == shownToken">{{ apiToken }}</span>
                            <span v-if="apiToken != shownToken">********************************************</span>
                            <icon v-if="apiToken == shownToken" @click.prevent="copyValue(apiToken)" type="regular" name="faCopy" aria-hidden="true" class="td-link ml-1 secondary"></icon>
                        </td>

                        <td class="td-text-right">
                            <button class="td-btn icon-left secondary-outlined slim mr-1" title="Show" @click="showApiToken(apiToken)">
                                <icon type="solid" :name="apiToken == shownToken ? 'faEyeSlash' : 'faEye'"></icon>
                                <span v-if="apiToken == shownToken">Hide</span>
                                <span v-if="apiToken != shownToken">Show</span>
                            </button>
                            <button class="td-btn icon-left danger slim ml-1" title="Remove" @click="showRemoveApiToken(apiToken)">
                                <icon type="solid" name="faTrash"></icon>
                                <span>Remove</span>
                            </button>
                        </td>
                    </tr>
                    <tr v-if="!isLoading && apiTokens.length == 0"><td colspan="2"><span>No API Authentication Tokens Created</span></td></tr>
                    <tr v-if="isLoading"><td colspan="2"><div class="loading loading-table"><icon name="faSpinner" type="solid" spin></icon></div></td></tr>
                </tbody>
            </table>
        </div>

        <div>
            <h2 class="td-h2">Webhooks</h2>
        </div>

        <div class="add-webhook my-2">
            <button @click="showAddWebhook" class="td-btn secondary icon-left"><icon class="icon" type="solid" name="faPlus"></icon>Add Webhook</button>
        </div>

        <div v-if="!verificationToken1" class="my-2">
            <button @click="showVerificationTokens" class="td-btn secondary-outline icon-left">Show Verification Tokens</button>
        </div>

        <div v-if="verificationToken1" class="my-2">
            <div><strong>Verification Token:</strong> {{ verificationToken1 }}</div>
            <div class="mt-2"><strong>Next Verification Token:</strong> {{ verificationToken2 }}</div>
            <button @click="showConfirmRotateModal = true" class="td-btn secondary-outline icon-left mt-2">Rotate Verification Tokens</button>
        </div>

        <div class="td-table-container mt-0">
            <table cellspacing="0" cellpadding="0" class="td-table">
                <thead>
                    <tr class="table-header">
                        <th>Address</th>
                        <th>Format</th>
                        <th>Verified</th>
                        <th class="td-text-right"></th>
                    </tr>
                </thead>
                <tbody class="rows-container">
                    <tr v-if="!isLoading && webhooksData.length > 0" v-for="webhook in webhooksData" class="table-row main-row">
                        <td class="address">
                            <span>{{ webhook.address }}</span>
                        </td>
                        <td class="format">
                            <span>{{ WebhookFormat[webhook.format] }}</span>
                        </td>
                        <td class="verified">
                            <icon class="positive" v-if="webhook.isVerified" type="solid" name="faCheck"></icon>
                            <icon class="negative" v-if="!webhook.isVerified" type="solid" name="faXmark"></icon>
                        </td>

                        <td class="td-text-right">
                            <button class="td-btn secondary-outlined slim mr-1" title="Verify" @click="verifyWebhook(webhook)">
                                Verify
                            </button>
                            <button class="td-btn danger slim mr-1" title="Remove" @click="removeWebhook(webhook)">
                                Remove
                            </button>
                        </td>
                    </tr>
                    <tr v-if="isLoading"><td colspan="5"><div class="loading loading-table"><icon name="faSpinner" type="solid" spin></icon></div></td></tr>
                    <tr v-if="webhooksData && webhooksData.length < 1 && !isLoading"><td colspan="5"><p>No webhooks registered.</p></td></tr>
                </tbody>
            </table>
        </div>

        <transition name="modal">
            <modal v-if="showConfirmRotateModal" @close="closeConfirmRotateModal" hide-footer>
                <div class="td-edit-container one-step">
                    <div class="pagination">
                        <div class="form-name">
                            <h3>Rotate your Validation Tokens</h3>
                        </div>
                        <div class="step-description">
                            <div class="step active">
                                <p>Please confirm you would like to rotate your validation tokens</p>
                            </div>
                        </div>
                    </div>
                    <div class="edit-pages">
                        <div>
                            <h3>Are you sure your want to rotate your validation tokens?</h3>
                            <p>The next token will start being used and the current token will be exired.</p>
                        </div>
                        <div class="actions">
                            <div>
                                <button class="td-btn primary-outlined" title="Cancel" @click.prevent="closeConfirmRotateModal">No</button>
                            </div>
                            <div class="save-btn">
                                <button class="td-btn secondary save-btn" title="Rotate Tokens" @click.prevent="rotateVerificationTokens" :disabled="isLoading">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
            </modal>
        </transition>

        <transition name="modal">
            <modal v-if="showAddWebhookModal" @close="closeAddWebhookModal" hide-footer>
                <add-webhook @cancel="closeAddWebhookModal" @added="addWebhookAddress"></add-webhook>
            </modal>
        </transition>

        <transition name="modal">
            <modal v-if="showRemoveWebhookModal" @close="closeRemoveWebhookModal" hide-footer>
                <div id="delete-channel" class="td-edit-container one-step">
                    <div class="pagination">
                        <div class="form-name">
                            <h3>Remove Webhook</h3>
                        </div>
                        <div class="step-description">
                            <div class="step active">
                                <p>Please confirm you would like to remove your webhook</p>
                            </div>
                        </div>
                    </div>
                    <div class="edit-pages">
                        <div>
                            <h3>Are you sure your want to remove your webhook?</h3>
                            <p class="address"><span>Webhook address: {{ showRemoveWebhookModal.address }}</span></p>
                        </div>
                        <div class="actions">
                            <div>
                                <button class="td-btn primary-outlined" title="Cancel" @click.prevent="closeRemoveWebhookModal">No</button>
                            </div>
                            <div class="save-btn">
                                <button class="td-btn secondary save-btn" title="Remove Webhook" @click.prevent="removeWebhookAddress" :disabled="isLoading">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
            </modal>
        </transition>

        <transition name="modal">
            <modal v-if="showVerifyWebhookModal" @close="closeVerifyWebhookModal" hide-footer>
                <verify-webhook :address="showVerifyWebhookModal" @cancel="closeVerifyWebhookModal" @verified="verifyWebhookAddress"></verify-webhook>
            </modal>
        </transition>

        <div v-if="showAddApiKeyModal">
            <add-api-key @cancel="cancelAddApiKey" :account-id="accountId" @update="updateList"></add-api-key>
        </div>

        <div v-if="showEditApiKeyModal">
            <edit-api-key :api-key="editApiKey" @cancel="cancelEditApiKey" @update="updateList"></edit-api-key>
        </div>

        <transition name="modal">
            <modal v-if="showRefreshApiKeyModal" @close="closeRefreshApiKey" hide-footer>
                <refresh-api-key :api-key="refreshApiKey" @update="refreshApiKeys"></refresh-api-key>
            </modal>
        </transition>

        <transition name="modal">
            <modal v-if="showRemoveApiKeyModal" @close="closeRemoveApiKey" hide-footer>
                <remove-api-key :api-key="removeApiKey" @update="updateList"></remove-api-key>
            </modal>
        </transition>

        <transition name="modal">
            <modal v-if="showRemoveApiTokenModal" @close="closeRemoveApiTokenModal" hide-footer>
                <div id="delete-channel" class="td-edit-container one-step">
                    <div class="pagination">
                        <div class="form-name">
                            <h3>Remove API Authentication Token</h3>
                        </div>
                        <div class="step-description">
                            <div class="step active">
                                <p>Please confirm you would like to remove your API authentication token</p>
                            </div>
                        </div>
                    </div>
                    <div class="edit-pages">
                        <div>
                            <h3>Are you sure your want to remove your API authentication token?</h3>
                            <p class="address"><span>Token: {{ showRemoveApiTokenModal }}</span></p>
                            <div class="td-banner danger">
                                <icon name="faCircleExclamation" type="solid"></icon>
                                <p>This will remove the token and prevent it from being used for authentication.  Please ensure that your app no longer uses this before removing.</p>
                            </div>
                        </div>
                        <div class="actions">
                            <div>
                                <button class="td-btn primary-outlined" title="Cancel" @click.prevent="closeRemoveApiTokenModal">No</button>
                            </div>
                            <div class="save-btn">
                                <button class="td-btn secondary save-btn" title="Remove Token" @click.prevent="removeApiToken" :disabled="isLoading">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
            </modal>
        </transition>

    </div>
</template>

<script>
    import script from './Integrations';
    export default script;
</script>

<style lang="less">
    @import './Integrations.less';
</style>